module.exports = __webpack_public_path__ + "static/image/main/m/banner-2-1.ver2_0_2.jpg?4c59fec4";